module.exports = __webpack_public_path__ + "static/media/name-global.c33981b0.png";